import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentImportHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/** A segment's "Add by CSV" screen, which forwards to the imports wizard while the flag is on. */
function JourneysSegmentNewImportRoute() {
  const { segmentId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSegmentImportHandoff segmentId={segmentId} step="new" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/new',
)({
  component: JourneysSegmentNewImportRoute,
});
